<template>
  <div class="mx-auto max-w-full lg:max-w-7xl px-4 sm:px-6 lg:px-8 space-y-6 sm:space-y-8 py-4 sm:py-6 lg:py-8">
    <PlanSelectionCard class="animate-slideUp" />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import PlanSelectionCard from "@/features/planSelection/PlanSelectionCard.vue";
import { useFormStore } from "@/features/blueprint/stores/useFormStore";
import { usePlanSelectionStore } from "@/features/planSelection/stores/usePlanSelectionStore";

const formStore = useFormStore();
const planStore = usePlanSelectionStore();
const route = useRoute();
const { locale } = useI18n();

onMounted(() => {
  // Load form data from localStorage to ensure recommendations are calculated
  formStore.loadFromLocalStorage();
  
  // Handle language parameter
  const urlLang = route.query.lang || route.query.locale;
  if (urlLang && (urlLang === 'en' || urlLang === 'nl')) {
    locale.value = urlLang;
  }
  
  // Handle URL parameters for preselected plans
  const urlPlans = route.query.plans;
  if (urlPlans) {
    let planIds: string[] = [];
    
    if (Array.isArray(urlPlans)) {
      // Multiple parameters: ?plans=id1&plans=id2&plans=id3
      planIds = urlPlans.filter(Boolean);
    } else if (typeof urlPlans === 'string') {
      // Single parameter with delimiters: ?plans=id1,id2,id3 or ?plans=id1|id2|id3
      if (urlPlans.includes('|')) {
        planIds = urlPlans.split('|').map(id => id.trim()).filter(Boolean);
      } else if (urlPlans.includes(',')) {
        planIds = urlPlans.split(',').map(id => id.trim()).filter(Boolean);
      } else {
        // Single plan
        planIds = [urlPlans.trim()].filter(Boolean);
      }
    }
    
    if (planIds.length > 0) {
      // Set URL preselected plans in store
      planStore.setUrlPreselectedPlans(planIds);
    }
  }
});
</script>
